import styled from 'styled-components';
import {Marker} from '../../Overlay';
import Icon from './street-view-marker.svg';

interface IProps {
  map: naver.maps.Map;
  position: naver.maps.LatLng;
}

export const GuideMarker = ({map, position}: IProps) => {
  return (
    <Marker map={map} position={position} draggable={false} clickable={false}>
      <Point>
        <Root>
          <img src={Icon} alt="거리뷰" />
        </Root>
      </Point>
    </Marker>
  );
};

const Root = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(calc(-50% + 1.5px), -100%);
`;

const Point = styled.div`
  position: relative;
  top: 0;
  left: 0;
`;
